var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcChecklist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/checklist"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8 2C4.68631 2 2 4.68631 2 8C2 11.3139 4.68631 14 8 14C11.3139 14 14 11.3139 14 8C14 4.68631 11.3139 2 8 2ZM8 13.2618C5.10519 13.2618 2.75 10.8948 2.75 7.99998C2.75 5.10516 5.10519 2.74998 8 2.74998C10.8948 2.74998 13.25 5.10518 13.25 7.99998C13.25 10.8948 10.8948 13.2618 8 13.2618ZM10.3946 5.80456L6.87424 9.347L5.28893 7.76169C5.14249 7.61525 4.90511 7.61525 4.75849 7.76169C4.61205 7.90812 4.61205 8.1455 4.75849 8.29194L6.61455 10.1482C6.76099 10.2944 6.99836 10.2944 7.14499 10.1482C7.16186 10.1313 7.17631 10.1129 7.18944 10.0938L10.9252 6.33499C11.0714 6.18855 11.0714 5.95118 10.9252 5.80456C10.7786 5.65813 10.5412 5.65813 10.3946 5.80456Z",
    fill: "#79808A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChecklist);
export default __webpack_public_path__ + "static/media/ic_checklist.0280d354525a1a8d53e5cf53eee598bc.svg";
export { ForwardRef as ReactComponent };